<template>
    <v-expansion-panels
      v-model="panel"
      id="filter-produkcard"
      tile
      accordion
      focusable
      class="accordion-filter"
    >
      <v-expansion-panel>
        <v-expansion-panel-header
          class="text-uppercase font-weight-bold text-body-2 px-3 py-3 mt-5"
        >
          <div><v-icon>mdi-filter-outline</v-icon>Filter</div>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="px-4 pt-4 pb-0 mt-2 border" outlined>
          <v-form>
            <!-- <v-row>
              <v-col cols="6" class="py-0">
                <v-text-field
                  v-model="productNameFilter.value"
                  outlined
                  small
                  dense
                  hide-details
                  class="searchInput"
                  placeholder="cari nama produk atau SKU"
                >
                  <div slot="append">
                    <v-btn small elevation="2" color="success">
                      <v-icon center>mdi-magnify</v-icon>
                    </v-btn>
                  </div>
                </v-text-field>
              </v-col>

              <v-col cols="6" class="py-0">
                <v-select
                  v-model="productCategoryFilter.value"
                  :items="category"
                  item-text="product_category_name"
                  item-value="product_category_id"
                  placeholder="Pilih Kategori"
                  outlined
                  multiple
                  dense
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="py-0">
                <v-row class="align-center">
                  <v-col cols="3" class="py-0">Stok</v-col>
                  <v-col cols="4" class="py-0">
                    <v-currency-field
                      v-model="productStockMinFilter.value"
                      outlined
                      small
                      dense
                      hide-details
                    ></v-currency-field>
                  </v-col>
                  <v-col cols="1" class="py-0">-</v-col>
                  <v-col cols="4" class="py-0">
                    <v-currency-field
                      v-model="productStockMaxFilter.value"
                      outlined
                      small
                      dense
                      hide-details
                    ></v-currency-field>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="6" class="py-0">
                <v-row class="align-center">
                  <v-col cols="3" class="py-0">Penjualan</v-col>
                  <v-col cols="4" class="py-0">
                    <v-currency-field
                      v-model="productSoldMinFilter.value"
                      outlined
                      small
                      dense
                      hide-details
                    ></v-currency-field>
                  </v-col>
                  <v-col cols="1" class="py-0">-</v-col>
                  <v-col cols="4" class="py-0">
                    <v-currency-field
                      v-model="productSoldMaxFilter.value"
                      outlined
                      small
                      dense
                      hide-details
                    ></v-currency-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row> -->
            <slot />
            <v-row>
              <v-col cols="12" class="text-right pb-0 pt-5 mt-3">
                <v-btn color="success" elevation="2" dark class="mr-3" width="140" @click="$emit('cari')">
                  <strong class="text-uppercase">Cari</strong>
                </v-btn>

                <v-btn color="error" elevation="2" outlined dark width="140" @click="$emit('reset')">
                  <strong class="text-uppercase">Reset</strong>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
  name: 'MemberSectionFilter',

  data() {
    return {
       panel: [0],
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>